export default "__VITE_ASSET__47187010__"